import { lazyload } from './modules/lazyload'
import { sidenavigation } from './modules/sidenavigation'
import { dialog } from './modules/dialog'
import { authenticate } from './modules/authenticate'
import { copy } from './modules/copy'
import { slider } from './modules/slider'
import { carrousel } from './modules/carrousel'
import { afbeeldingSlider } from './modules/afbeeldingSlider'
import { password } from './modules/password'
import { copyShare } from './modules/copy-share'
import { copyShareStory } from './modules/copy-share-story'

window.GetHooked = {}

const afterLoad = () => {
    sidenavigation.init()
    lazyload.init()
    dialog.init()
    authenticate.init()
    copy.init()
    slider.init()
    carrousel.init()
    afbeeldingSlider.init()
    password.init()
    copyShare.init()
    copyShareStory.init()
}

document.addEventListener('DOMContentLoaded', afterLoad)
